import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = [
        'snippet',
    ]

    snippetTargetConnected(element) {
        this.updateClasses()
    }

    snippetTargetDisconnected(element) {
        this.updateClasses()
    }

    updateClasses() {
        let lastValue = null

        this.snippetTargets.forEach(element => {
            const date = element.getAttribute(this.dateAttributeName)

            element
                .classList.
                toggle('border-t', date !== lastValue)

            element
                .querySelector(`[${this.dateAttributeName}]`)
                .classList.
                toggle('invisible', date === lastValue)

            lastValue = date
        });
    }

    get dateAttributeName() {
        return `data-${this.identifier}-date`
    }
}
